module.exports = __webpack_public_path__ + "img/BmHabitatMall-Mysuru.bf2e8e24.png";